import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import dayjs from 'dayjs'
import VueSocialSharing from 'vue-social-sharing'
import tippy from "tippy.js"

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { storageOptions } from '@/config'

//主题色
import './assets/style/element-variables.scss'
import { initThemeColor } from './utils/themeColorClient.js'
initThemeColor()

import "tippy.js/dist/tippy.css";

import './assets/style/index.scss'

// 国际化
import VueI18n from 'vue-i18n'

//google map
import * as VueGoogleMaps from '@busability/vue2-google-maps'

import VueCountryCode from 'vue-country-code'

import VueCountryIntl from 'vue-country-intl'
import 'vue-country-intl/lib/vue-country-intl.css'
Vue.component(VueCountryIntl.name, VueCountryIntl)

import VueCountryFlag from 'vue-country-intl/lib/vue-country-flag.min.js'
import 'vue-country-intl/lib/vue-country-flag.css'
// 引入svg图标
let flagFilePath = require.context('vue-country-intl/lib/country-flag-svgs', true, /\.svg$/)
Vue.use(VueCountryFlag, flagFilePath)

import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs

Vue.use(ElementUI, { locale })
Vue.use(Storage, storageOptions)
Vue.use(VueAwesomeSwiper)
Vue.use(VueI18n)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDvZcbzOba7slvQcdQ6qDlZB7rGBfnEaAI',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from '@busability/vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
})
Vue.use(VueCountryCode)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueSocialSharing)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')


